import { updateStore } from 'core_main/store';
import Pubnub from 'pubnub';
import {
  PUBNUB_ACCESS_DENIED_CATEGORY,
  PUBNUB_NETWORK_DOWN_CATEGORY,
  PUBNUB_NETWORK_RECONNECTED_CATEGORY,
  PUBNUB_NETWORK_UP_CATEGORY,
} from '../constants';
import {
  isAuthTokenExpired,
  setupGrantTokenRefresh,
  teardownGrantTokenRefresh,
} from '../helpers/grantToken';

export function createPubnubNetworkStatusEventHandler(outboundChatEnabled) {
  // this listener returns a promise for ease of testing but pubnub does nto wait for the promise returned to resolve
  return (statusEvent: Pubnub.StatusEvent) => {
    const { category } = statusEvent;
    if (category === PUBNUB_NETWORK_DOWN_CATEGORY) {
      teardownGrantTokenRefresh();
    } else if (
      category === PUBNUB_NETWORK_RECONNECTED_CATEGORY ||
      category === PUBNUB_NETWORK_UP_CATEGORY ||
      category === PUBNUB_ACCESS_DENIED_CATEGORY
    ) {
      if (isAuthTokenExpired()) {
        return setupGrantTokenRefresh(outboundChatEnabled).catch(() => {
          updateStore('isPubNubConnected', false);
        });
      }
    }
    return Promise.resolve();
  };
}
